import {
    FETCH_MISC_CHARGES_LOADING,
    FETCH_MISC_CHARGES_ERROR,
    FETCH_MISC_CHARGE_BY_ID_SUCCESS,
    FETCH_MISC_CHARGE_TYPES_SUCCESS,
    FETCH_MISC_CHARGE_TYPES_BY_ID_SUCCESS,
    FETCH_MISC_CHARGE_RATES,
    FETCH_MISC_CHARGE_RATES_SPECIFIC,
    FETCH_MISC_CHARGE_MERCHANDISERS_SUCCESS
} from "api/menu/master-files/misc-charges/actions";

const initialState = {
    loading: false,
    errors: [],
    miscCharge: {},
    miscChargeTypes: [],
    miscChargeTypesSingle: {},
    miscChargeRates: {},
    miscChargeRatesSpecific: {},
    miscChargeMerchandisers: []
};

export default function(state = initialState, action) {
    switch (action.type) {
        case FETCH_MISC_CHARGES_LOADING:
            return {
                ...state,
                loading: action.payload
            };
        case FETCH_MISC_CHARGES_ERROR:
            return {
                ...state,
                loading: false,
                errors: action.payload,
            };
        case FETCH_MISC_CHARGE_BY_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                miscCharge: action.payload
            };
        case FETCH_MISC_CHARGE_TYPES_SUCCESS:
            return {
                ...state,
                loading: false,
                miscChargeTypes: action.payload
            };
        case FETCH_MISC_CHARGE_TYPES_BY_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                miscChargeTypesSingle: action.payload
            };
        case FETCH_MISC_CHARGE_RATES:
            return {
                ...state,
                loading: false,
                miscChargeRates: action.payload
            };
        case FETCH_MISC_CHARGE_RATES_SPECIFIC:
            return {
                ...state,
                loading: false,
                miscChargeRatesSpecific: action.payload
            };
        case FETCH_MISC_CHARGE_MERCHANDISERS_SUCCESS:
            return {
                ...state,
                loading: false,
                miscChargeMerchandisers: action.payload
            };
        default:
            return state;
    }
}
